import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, map, take, tap } from 'rxjs/operators';
import { CurBaseService } from './firebase/curbase.service';
import { OappService } from 'src/app/shared/services/oapp.service';

interface ErroValidate {
[s:string]: boolean
}

@Injectable({
  providedIn: 'root'
})
export class ValidatorsService {
  empresa: any;

  constructor(private curBaseService:CurBaseService, private oappService:OappService) { }

  existeEmpresa():ValidatorFn{
    return (control:AbstractControl): Promise<ErroValidate> | Observable <ErroValidate> =>{
      if(!control.value){
        return Promise.resolve(null)
      }
        const link =`empresas`
        //buscar nit en netsolin_ini por si no se encuentra en firebase
        var searchnit = this.oappService.nits_prefijosbd.find(x => x.nit == control.value.replace(/ /g, ''));
        return this.curBaseService.consultaCollectionWhereFb(link,'code',control.value.replace(/ /g, ''),'==').pipe(
          debounceTime(500),
          take(1),
          map(arr => {
            //Si no encuentra en firebase, retorna respuesta del netsolin ini
              return arr.length>0 ? null : searchnit != undefined ? null : { existeEmpre: false };
          }),
        )
    }
  }
  existeEmail():ValidatorFn{
    return (control:AbstractControl): Promise<ErroValidate> | Observable <ErroValidate> =>{
      if(!control.value){
        return Promise.resolve(null)
      }
      return this.curBaseService.getGroupQuery('userProfile','email',control.value.toLocaleLowerCase().replace(/ /g, '')).pipe(
        debounceTime(500),
        take(1),
        map(arr => {
            return arr.length>0 ? { existeEmail: false } :null;
        }),
      )}
  }

  existeId():ValidatorFn{
    return (control:AbstractControl): Promise<ErroValidate> | Observable <ErroValidate> =>{
      if(!control.value){
        return Promise.resolve(null)
      }
      return this.curBaseService.getGroupQuery('userProfile','id',control.value.replace(/ /g, '')).pipe(
        debounceTime(500),
        take(1),
        map(arr => {
            return arr.length>0 ? { existeId: false } :null;
        }),
      )}
  }

}
